import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  variant?: 'dark' | 'darker';
}
export function Section({
  children,
  className = '',
  id,
  variant = 'dark'
}: SectionProps) {
  const bgColors = {
    dark: 'bg-neutral-950',
    darker: 'bg-black'
  };
  return <section id={id} className={`relative py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden ${bgColors[variant]} ${className}`} data-id="element-177">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-178">{children}</div>
    </section>;
}